import React from "react";
import { ConfigureModal } from "./ConfigureValuebetModal.styled";
import { ConfigureValuebetForm } from "./ConfigureValuebetForm";

export const ConfigureValuebetModal = React.memo(function ConfigureValuebetModal({ show, setVisible }) {
  const close = () => {
    setVisible(false);
  };

  return (
    <ConfigureModal show={show} onHide={close} centered>
      <ConfigureModal.Header className="pb-0 border-bottom-0" closeButton>
        <ConfigureModal.Title>Configuración</ConfigureModal.Title>
      </ConfigureModal.Header>
      <ConfigureModal.Body className="pt-0">
        <ConfigureValuebetForm closeModal={close}/>
      </ConfigureModal.Body>
    </ConfigureModal>
  );
});
